import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import MessagesObject from '~/interfaces/MessagesObject';

type RecipientDetailsType = {
  id: number,
  recipient_email: string,
  recipient_name: string,
  department_name:string,
  has_request_to_upload_file: boolean,
  details: string,
  status: number,
  rfi_conversation?: {
    id: string,
    recipient_full_name: string;
    recipient_email: string;
    conversation_subject: string;
    messages?: MessagesObject[]
  },
};

type ToastType = {
  message: string,
  severity: string,
  isOpen: boolean
};


type SecurePortalState = {
  item: RecipientDetailsType,
  uniqueId: string,
  toast: ToastType
};



const initialState: SecurePortalState = {
  uniqueId: '',
  item: {
    id: 0,
    recipient_email: '',
    recipient_name: '',
    department_name: '',
    has_request_to_upload_file: false,
    details: '',
    status: 0,
    rfi_conversation: undefined,
  },
  toast: {
    message: 'Test',
    severity: 'success',
    isOpen: true,
  },
};

export const securePortalSlice = createSlice({
  name: 'securePortal',
  initialState,
  reducers: {
    setToast: (state, action: PayloadAction<ToastType>) => {
      state.toast = action.payload;
    },
    setItem: (state, action: PayloadAction<RecipientDetailsType>) => {
      state.item = action.payload;
    },
    setUniqueId: (state, action: PayloadAction<string>) => {
      state.uniqueId = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setItem,
  setUniqueId,
  setToast,
} = securePortalSlice.actions;

export default securePortalSlice.reducer;